import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import FolderCard from '../../../../FolderCard';
import GallectionControlButtons from '../../GallectionControlButtons';
import withCurrentSubfolder from '../../../_hocs/withCurrentSubfolder';
import s from './ManageableSubfolder.scss';
const enhance = compose(withCurrentSubfolder);
export const ManageableSubfolder = ({ subfolder, existingGallectionNames, className, currentSubfolderId, setCurrentSubfolderId })=>{
    const isSelected = subfolder.folderId === currentSubfolderId;
    return /*#__PURE__*/ React.createElement(FolderCard, {
        width: 128,
        isSelected: isSelected,
        onClick: ()=>setCurrentSubfolderId(subfolder.folderId),
        withLink: false,
        className: classnames(s['subfolder-card'], className),
        key: subfolder.folderId,
        folder: subfolder,
        extras: /*#__PURE__*/ React.createElement(GallectionControlButtons, {
            className: classnames(s['gallection-control-buttons'], isSelected && s['gallection-control-buttons-on-selected']),
            moreMenuClassName: s['gallection-control-menu'],
            gallection: subfolder,
            existingGallectionNames: existingGallectionNames
        })
    });
};
ManageableSubfolder.displayName = 'ManageableSubfolder';
export default enhance(ManageableSubfolder);

//# sourceMappingURL=ManageableSubfolder.js.map